// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3ZO1c","image":"App_image__1H0Fh"};